import { render, staticRenderFns } from "./OffersList.vue?vue&type=template&id=07b035fc&"
import script from "./OffersList.vue?vue&type=script&lang=js&"
export * from "./OffersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports